<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">PC本地部署大模型</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">PC本地部署大模型</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						PC本地部署大模型強調數據本地化處理，避免敏感數據上傳雲端，從源頭保障隱私安全。通過模型蒸餾與參數壓縮技術，將百億級大模型優化為輕量化版本，適配消費級硬件。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">功能亮點</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">一鍵部署與輕量化運行</div>
									<div class="t2">
										零配置啟動：提供圖形化安裝包，用戶僅需點擊即可完成模型部署，無需命令行或環境調試<br>
										硬件兼容性：支援CPU/GPU混合推理，最低可在RTX 3060或16GB記憶體的PC上流暢運行7B~13B參數模型
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">多模型自由切換</div>
									<div class="t2">
										模型倉庫集成：預置Llama、Qwen、DeepSeek等主流開源模型，用戶可按需加載不同模型應對多樣化任務<br>
										離線全功能支援：所有模型推理、訓練、知識庫構建均可在斷網環境下完成，徹底擺脫雲端依賴
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">私密知識庫構建與管理</div>
									<div class="t2">
										智能文檔處理：支援Word、PDF、圖片等文件一鍵導入，自動完成文本解析、標籤分類與向量化存儲<br>
										結構化知識網絡：生成可關聯的私有知識圖譜，用戶可通過自然語言快速檢索內部文檔
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">開箱即用場景工具箱</div>
										<div class="t2">
											AI幫寫：自動生成郵件、報告、合同初稿<br>
											智能潤色：語法校正與專業術語優化
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/pc1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">應用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/pc2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">個人知識管家</div>
										<div class="t2">
											自動歸檔學習筆記、論文，支援語義檢索與關聯推薦
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">企業法務助手</div>
										<div class="t2">
											合同條款智能審查、風險點提示，基於私有庫生成合規報告
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">行業專家系統</div>
									<div class="t2">
										注入領域知識（如航運、醫療），提供實時決策支援（如船舶調度、診斷輔助）
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">創作工作室</div>
									<div class="t2">
										多輪內容優化、風格遷移（如技術文檔轉科普文案）
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">技術亮點</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">輕量化模型壓縮</div>
										<div class="t2">
											採用GGUF/GPTQ量化技術，70B模型壓縮後顯存佔用降低60%，精度損失 < 3%
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多模型容器化管理</div>
										<div class="t2">
											通過輕量級虛擬化隔離不同模型環境，避免依賴衝突
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">本地向量數據庫</div>
										<div class="t2">
											集成LanceDB等輕量引擎，實現億級向量秒級檢索
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/pc3.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>


		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心優勢</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/pc4.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據安全與隱私保障</div>
										<div class="t2">
											全鏈路本地化：數據存儲、訓練、推理均在用戶設備完成，杜絕第三方洩露風險<br>
											企業級加密支援：敏感文件存儲採用硬件級加密，滿足金融、醫療等強合規行業需求
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">低成本與高性價比</div>
										<div class="t2">
											硬件門檻低：無需專業服務器，普通PC即可部署，顯著降低綜合成本<br>
											零持續費用：一次部署永久使用，無API調用費或訂閱支出
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">靈活性與場景適配</div>
										<div class="t2">
											模塊化擴展：支援插件式集成新模型或工具（如OCR識別、多語言翻譯）<br>
											跨行業兼容：適配法律、航運、醫療等垂直領域，通過私有知識庫注入專業能力（如海事法規精準問答）
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">生產力躍升</div>
										<div class="t2">
											效率提升：文檔處理速度提升3倍，報告生成耗時從小時級縮短至分鐘級<br>
											人機協同革新：員工可專注高階決策，機械性任務交由AI處理
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
